export default __webpack_public_path__ + "static/media/Levitate D3.1 A taxonomy of potential impacts.125c9d35.pdf";